.card {
  display: flex;
  flex-direction: column;
  gap: var(--ic-space-3);
  padding: var(--ic-space-5);
  border: 1px solid var(--ic-card-border);
  border-radius: var(--ic-radius-lg);
  background: var(--ic-card-bg);
  color: var(--ic-fg);
}

/* Card interattiva: l'intera area è cliccabile grazie a un pseudo-elemento
   sopra la card, ancorato all'UNICO link/bottone interno. Così l'albero di
   accessibilità vede un solo elemento focalizzabile con l'etichetta giusta —
   niente `onClick` su un <div> con `role="button"` e `tabIndex`, che è la
   scorciatoia che rompe la navigazione da tastiera. */
.interactive {
  position: relative;
  transition:
    border-color var(--ic-duration-base) var(--ic-easing),
    box-shadow var(--ic-duration-base) var(--ic-easing);
}
.interactive:hover {
  border-color: var(--ic-card-hover-border);
  box-shadow: var(--ic-shadow-md);
}
/* Il ring di focus appare sulla CARD quando il link interno riceve il focus. */
.interactive:focus-within {
  outline: var(--ic-focus-width) solid var(--ic-focus-color);
  outline-offset: var(--ic-focus-offset);
}
.interactive .titleLink::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
}
/* Il link non ha il proprio outline: ce l'ha la card via :focus-within. */
.interactive .titleLink:focus-visible {
  outline: none;
}

.eyebrow {
  color: var(--ic-fg-subtle);
  font-size: var(--ic-text-xs);
  font-weight: var(--ic-weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.title {
  font-size: var(--ic-text-lg);
  font-weight: var(--ic-weight-semibold);
  line-height: var(--ic-leading-tight);
  margin: 0;
}

.titleLink {
  color: var(--ic-fg);
  text-decoration: none;
}
.titleLink:hover {
  color: var(--ic-link-hover);
  text-decoration: underline;
}

.body {
  color: var(--ic-fg-muted);
  font-size: var(--ic-text-sm);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ic-space-3);
  margin-top: auto;
  padding-top: var(--ic-space-3);
  border-top: 1px solid var(--ic-border);
  /* position: relative + z-index per stare SOPRA il pseudo-elemento della
     card interattiva: i bottoni del footer devono restare cliccabili. */
  position: relative;
  z-index: 1;
}

.grid {
  display: grid;
  gap: var(--ic-space-4);
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 17rem), 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
}
